import { getUserInfo } from '@/api/sign';
import store from "../index";
import configR from '@/configs.js';
let envSystemSetting = {};
try {
  let tempSS = JSON.parse(configR.envConfigs.SYSTEM_CONFIG);
  envSystemSetting = tempSS.data;
}catch (e) {
  console.log(e)
}
const state = {
  systemStatus:'', // 系统状态，SystemUpdating -- 升级中；404 -- 404； Error -- 网络错误
  systemStatusSetting:["SystemUpdating","Error"],
  userIdentity: 'Tourist',
  token: '',
  ticket: '',
  userInfo: {},
  themeConfig: {},
  touristThemeConfig:null,
  systemSetting: envSystemSetting,
  userNav: [
  ],
  userWhiteNavs: [],
  userRoles: [],
  superAmin :false,
  userAuthedWhiteNavs:[],
  businessManageNav:[],
  userDesktop: [],
  organizationName:'',
  refresh:false,

  userModules: [
    {
      code: 'Serve',
      name: '我的服务',
      modulePreview: 'http://minio.dice.supwisdom.com/cms/a82eb7387090d053b9c1cc56a9278ecf.png',
      sortNum: 1,
      edit: true,
      show: true,
    },
    {
      code: 'News',
      name: '校园新闻',
      modulePreview: 'http://minio.dice.supwisdom.com/cms/a82eb7387090d053b9c1cc56a9278ecf.png',
      sortNum: 2,
      edit: true,
      show: true,
    },
    {
      code: 'Schedule',
      name: '我的日程',
      modulePreview: 'http://minio.dice.supwisdom.com/cms/a82eb7387090d053b9c1cc56a9278ecf.png',
      sortNum: 3,
      edit: true,
      show: true,
    },
    {
      code: 'TimeServe',
      name: '日常工作',
      modulePreview: 'http://minio.dice.supwisdom.com/cms/a82eb7387090d053b9c1cc56a9278ecf.png',
      sortNum: 4,
      edit: true,
      show: true,
    },
  ],
  userButtons: [],
  userDefaultNav: {},
  userGolbalSearch: '',
  columnID: '',
};

const mutations = {
  SET_SYSTEM_STATUS: (state, systemStatus) => {
    state.systemStatus = systemStatus;
  },
  SET_SYSTEM_SETTING: (state, systemSetting) => {
    state.systemSetting = systemSetting;
  },
  SET_USER_THEME_CONFIG: (state, themeConfig) => {
    state.themeConfig = themeConfig;
  },
  SET_TOURIST_THEME_CONFIG: (state, touristThemeConfig) => {
    state.touristThemeConfig = touristThemeConfig;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_TOKEN_EXPIRY_DATE: (state, tokenExpiryDate) => {
    state.tokenExpiryDate = tokenExpiryDate;
  },
  SET_TICKET: (state, ticket) => {
    state.ticket = ticket;
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_USER_IDENTITY: (state, userIdentity) => {
    state.userIdentity = userIdentity;
  },
  SET_USER_NAV: (state, userNav) => {
    state.userNav = userNav;
  },
  SET_USER_WHITE_NAVS: (state, userWhiteNavs) => {
    state.userWhiteNavs = userWhiteNavs;
  },
  SET_USER_AUTHED_WHITE_NAVS: (state, userAuthedWhiteNavs) => {
    state.userAuthedWhiteNavs = userAuthedWhiteNavs;
  },
  SET_BUSINESS_MANAGE_NAV: (state, businessManageNav) => {
    state.businessManageNav = businessManageNav;
  },
  SET_USER_ROLE: (state, resRoleData) => {
    state.userRoles = resRoleData;
    // 判断是否是超级管理员
    state.superAmin = resRoleData.indexOf("6") > -1
  },
  SET_USER_DESKTOP: (state, userDesktop) => {
    state.userDesktop = userDesktop;
  },
  SET_USER_MODULES: (state, userModules) => {
    state.userModules = userModules;
  },
  SET_USER_BUTTON: (state, buttons) => {
    state.userButtons = buttons;
  },
  GET_TOKEN: state => {
    //state.token = getToken();
  },
  SET_USER_GOLBALSEARCH: (state, value) => {
    state.userGolbalSearch = value;
  },
  SET_COLUMN_ID: (state, newColumnId) => {
    state.newColumnId = newColumnId;
  },
  SET_NETWORK_REMIND: (state, networkRemind) => {
    state.networkRemind = networkRemind;
  },
  SET_UNIAITH_NONCE: (state, nonce) => {
    state.uniAuthNonce = nonce;
  },
  SET_ORGANIZATION_NAME:(state, organizationName) => {
    state.organizationName = organizationName;
  },
  SET_REFRESH_STATUS:(state, refresh) => {
    state.refresh = refresh;
  },


};

const actions = {
  // 获取用户信息
  async getInfo({ commit }) {
    let res = await getUserInfo();
    commit('SET_USER_INFO', res.data);
  },

  // 登出
  async signOut({ commit }) {
    commit('SET_TOKEN', '');
    commit('SET_TOKEN_EXPIRY_DATE', '');
    commit('SET_TICKET', '');
    commit('SET_USER_IDENTITY', 'Tourist');
    commit('SET_ROLES', []);
    commit('SET_USER_INFO', []);
    commit('SET_USER_NAV', []);
    commit('SET_BUSINESS_MANAGE_NAV', []);
    commit('SET_USER_WHITE_NAVS', []);
    commit('SET_USER_ROLE', []);
    commit('SET_USER_THEME_CONFIG',{})
    commit('SET_SYSTEM_STATUS', '');
  },
  // 重新登录
  async resetToken({ commit, dispatch }) {
    await dispatch('signOut');
  },
};
export default {
  state,
  mutations,
  actions,
};
